import { useEffect, useState } from "react";

export interface FleetFilters {
  search: string;
  estado: string;
  gerencia: string;
}

interface Props {
  value: FleetFilters;
  estados: string[];
  gerencias: string[];
  onChange: (next: FleetFilters) => void;
}

export function FleetFiltersBar({
  value,
  estados,
  gerencias,
  onChange,
}: Props) {
  const [local, setLocal] = useState(value);

  // Sync external changes back to the local state.
  useEffect(() => setLocal(value), [value]);

  const commit = (next: FleetFilters) => {
    setLocal(next);
    onChange(next);
  };

  return (
    <div className="flex flex-wrap items-center gap-2 px-3 py-2 border-b border-border bg-surface">
      <input
        className="input flex-1 min-w-[180px]"
        placeholder="Buscar por alias, placa, operador…"
        value={local.search}
        onChange={(e) => commit({ ...local, search: e.target.value })}
        data-testid="fleet-filter-search"
      />
      <select
        className="select"
        value={local.estado}
        onChange={(e) => commit({ ...local, estado: e.target.value })}
        data-testid="fleet-filter-estado"
      >
        <option value="">Todos los estados</option>
        {estados.map((e) => (
          <option key={e} value={e}>
            {e}
          </option>
        ))}
      </select>
      <select
        className="select"
        value={local.gerencia}
        onChange={(e) => commit({ ...local, gerencia: e.target.value })}
        data-testid="fleet-filter-gerencia"
      >
        <option value="">Todas las gerencias</option>
        {gerencias.map((g) => (
          <option key={g} value={g}>
            {g}
          </option>
        ))}
      </select>
      {(local.search || local.estado || local.gerencia) && (
        <button
          className="btn-ghost text-xs"
          onClick={() =>
            commit({ search: "", estado: "", gerencia: "" })
          }
          data-testid="fleet-filter-clear"
        >
          Limpiar
        </button>
      )}
    </div>
  );
}
